import React from 'react';
import {Route, Switch} from "react-router-dom";
import NotFound from "./components/NotFound";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Main from "./components/Main";
import MeetingSignIn from "./components/MeetingSignIn";
import PendingManualApprove from "./components/meeting/PendingManualApprove";
import Horas from "./components/dicoex/Horas";

const App = () => {

    String.prototype.format = function () {
        let a = this;
        for (let k in arguments) {
            a = a.replace("{" + k + "}", arguments[k])
        }
        return a
    }

    return (
        <div className="App">
            <Container component="main" maxWidth="lg">
                <CssBaseline/>
                <Switch>
                    <Route path="/login/:meeting_id/:horas" exact component={MeetingSignIn}/>
                    <Route path="/login/:meeting_id" exact component={MeetingSignIn}/>
                    <Route path="/meeting/:meeting_id/pending" exact component={PendingManualApprove}/>
                    <Route path="/meeting/:meeting_id/horas"  exact component={Horas}/>
                    <Route path="/meeting/:meeting_id"  component={Main}/>
                    <Route component={NotFound}/>
                </Switch>
            </Container>
        </div>
    );
}

export default App;
